export const pageTitle = 'MEG IBE';

export const contact = {
  emailLabel: 'info.its@iso-gruppe.com',
  emailLink: 'mailto:info.its@iso-gruppe.com',
  phoneLabel: '+49 911 995940',
  phoneLink: 'tel:+49911995940',
  location: 'https://goo.gl/maps/x3vPk5MijbYGz1KN8'
};
